import { all, put, takeLatest, call } from 'redux-saga/effects';
import { getPriceByProduct } from 'yoda-interfaces/lib/Product/PricingApi';
import {
    PRODUCT_COLLECTION_PRICING_GET_SUCCESS,
    PRODUCT_COLLECTION_PRICING_GET_REQUEST,
} from '../actionTypes/ProductCollectionPricingActionTypes';

export const mergeCollectionData = (productCollectionPrice, productCollection) => {
    let productCollectionListToRender = [];
    productCollectionListToRender = productCollection.map((item) => {
        const priceItem = productCollectionPrice.find(({ id }) => id === item.id);
        // Merge data if product ID of price list matches with product list ID
        if (priceItem && item.id === priceItem.id && priceItem.amounts) {
            return {
                ...item,
                priceDetails: priceItem,
            };
        }
        return item;
    });
    return productCollectionListToRender;
};

let productCollectionData = [];
function* fetchProductCollectionPrice({ productCollection }) {
    try {
        const productCollectionPrice = yield call(getPriceByProduct, productCollection);

        productCollectionData = yield call(
            mergeCollectionData,
            productCollectionPrice,
            productCollection
        );

        yield all([
            put({
                type: PRODUCT_COLLECTION_PRICING_GET_SUCCESS,
                productCollection: productCollectionData,
            }),
        ]);
    } catch (error) {
        yield put({ type: 'CONTENT_ERROR', error });
    }
}

const watchProductCollectionPricingSaga = function* watchProductCollectionPricingSaga() {
    yield takeLatest(PRODUCT_COLLECTION_PRICING_GET_REQUEST, fetchProductCollectionPrice);
};

watchProductCollectionPricingSaga.sagaName = 'productCollectionPricingSaga';
export default watchProductCollectionPricingSaga;
